import * as React from "react"
import LogoSVG from "app/layout/LogoSVG"

export default function MenuLogo() {
    return <a href="/" className="menuLogo" aria-label="PriceSeeker home"><LogoSVG logoType="ico" /></a>
}